import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import ReadMoreText from "./ReadMoreText";

import "swiper/css";
import "swiper/css/pagination";

function Process() {
  const [isSlider, setIsSlider] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSlider(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const steps = [
    {
      num: "01",
      title: "Share Your Need",
      desc: "Tell us your data requirement — industry, geography, volume, format.",
    },
    {
      num: "02",
      title: "Scope & Quote",
      desc: "We scope and send a clear, transparent quote. No hidden costs.",
    },
    {
      num: "03",
      title: "Verify & Clean",
      desc: "Every record validated and cleaned before delivery.",
    },
    {
      num: "04",
      title: "Delivered & Live",
      desc: "Receive via API, cloud or file — ready to use instantly.",
    },
  ];

  return (
    <section id="process" className="process-section">
      <div className="container">

        {/* Header */}
        <div className="process-header">
          <span className="section-label">HOW IT WORKS</span>
          <h2 className="section-title">Get Your Data in 4 Simple Steps</h2>
          <p className="section-sub">
            From requirement to delivery — fast, transparent, zero hassle.
          </p>
        </div>

        {/* 🔁 CONDITION */}
        {isSlider ? (

          /* 🔥 PREMIUM SLIDER (Mobile + Laptop) */
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            centeredSlides={true}
            loop={true}
            autoplay={{ delay: 2500 }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1.2 },
              768: { slidesPerView: 2 },
            }}
          >
            {steps.map((step, index) => (
              <SwiperSlide key={index}>
                <div className="process-card slider-card">
                  <div className="process-circle">{step.num}</div>
                  <div className="process-content">
                    <h4>{step.title}</h4>
                    <ReadMoreText text={step.desc} />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        ) : (

          /* 🖥 DESKTOP TIMELINE */
          <div className="process-wrapper">
            <div className="process-line"></div>

            {steps.map((step, index) => (
              <div className="process-card" key={index}>
                <div className="process-circle">{step.num}</div>
                <div className="process-content">
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}

          </div>

        )}

      </div>
    </section>
  );
}

export default Process;